var render = function render(){var _vm=this,_c=_vm._self._c;return _c('AnalyticsTemplate',{attrs:{"page-title":"桥梁偏航统计","chart-type":"deviation"}})
}
var staticRenderFns = []

export { render, staticRenderFns }